// extracted by mini-css-extract-plugin
module.exports = {"sticky":"FrontPageProducts_sticky__3gFrB","root":"FrontPageProducts_root__1SBwp"};